import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.64167 1.95538C3.85138 0.907154 5.399 0.331147 6.99967 0.33338C10.6817 0.33338 13.6663 3.31805 13.6663 7.00005C13.6663 8.42405 13.2197 9.74405 12.4597 10.8267L10.333 7.00005H12.333C12.3331 5.95446 12.0258 4.93192 11.4494 4.05955C10.8731 3.18719 10.053 2.50349 9.09113 2.09346C8.12929 1.68344 7.06815 1.56518 6.03965 1.75339C5.01114 1.9416 4.06064 2.42798 3.30634 3.15205L2.64167 1.95538ZM11.3577 12.0447C10.148 13.0929 8.60035 13.6689 6.99967 13.6667C3.31767 13.6667 0.333008 10.682 0.333008 7.00005C0.333008 5.57605 0.779674 4.25605 1.53967 3.17338L3.66634 7.00005H1.66634C1.66626 8.04563 1.97351 9.06818 2.5499 9.94054C3.12629 10.8129 3.94639 11.4966 4.90822 11.9066C5.87006 12.3167 6.9312 12.4349 7.9597 12.2467C8.98821 12.0585 9.9387 11.5721 10.693 10.848L11.3577 12.0447Z"
      fill="white"
      fillOpacity="0.65"
    />
  </svg>
);
export default SVGComponent;
